import {
  deleteDashboardModelGroup,
  deleteDashboardModels,
  getDashboardModelGroup,
  getDashboardModels,
  setDashboardModelGroup,
  setDashboardModels
} from '../storage.service';

export class DashboardModelsKeyService {
  get dashboardModelsKey() {
    return getDashboardModels;
  }

  get dashboardModelGroupKey() {
    return getDashboardModelGroup;
  }

  setDashboardModelsKey(dashboardModelsKeyValue: any) {
    setDashboardModels(dashboardModelsKeyValue);
  }

  setDashboardModelGroupKey(dashboardModelGroupKey: any) {
    setDashboardModelGroup(dashboardModelGroupKey);
  }

  removeDashboardModelsKeys() {
    deleteDashboardModels();
  }

  removeDashboardModelGroupKey() {
    deleteDashboardModelGroup();
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/visual/dashboardModelsKey.service.ts